// Module
var code = `<iframe ng-src="{{\$ctrl.finalSrc}}" class="h-100 w-100" frameborder="0"> </iframe> `;
// Exports
var _module_exports =code;;
var path = '/common/components/pdf_viewer/pdf-viewer.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;